import { render, staticRenderFns } from "./MedicalOrganization.vue?vue&type=template&id=4ecd2c59&scoped=true"
import script from "./MedicalOrganization.vue?vue&type=script&lang=js"
export * from "./MedicalOrganization.vue?vue&type=script&lang=js"
import style0 from "./MedicalOrganization.vue?vue&type=style&index=0&id=4ecd2c59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd2c59",
  null
  
)

export default component.exports